<template>
  <div id="app">
    <keep-alive  include='app'>
      <router-view/>
    </keep-alive>

  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
      viewsList:[]
    }
  },
  created() {

  }

}
</script>

<style lang="scss" scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  width: 100vw;
  height: 100vh;
  background-color: #FFFFFF;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue